import React from 'react';
import { MessageBar } from 'office-ui-fabric-react/lib/MessageBar';
import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
export const FieldInfoMessage = _ref => {
  let {
    children = null
  } = _ref;
  if (!children) return /*#__PURE__*/_jsx(_Fragment, {});
  return /*#__PURE__*/_jsx(MessageBar, {
    isMultiline: true,
    dismissButtonAriaLabel: "Close",
    children: children
  });
};